import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const EmailConfirmation = ({ isPayment }) => {
  const [emailConfirm, setEmailConfirm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Poll the is-authenticated endpoint at a safe interval (10s)
    // Stop polling when authenticated or after a timeout (e.g., 5 minutes)
    const intervalMs = 10000; // 10 seconds
    const maxAttempts = 30; // ~5 minutes
    let attempts = 0;
    let intervalId = null;

    const checkAuthentication = async () => {
      try {
        const sb_id = JSON.parse(localStorage.getItem("sb_id"));
        if (!sb_id || !sb_id.id) {
          console.log("No user ID found in local storage.");
          return false;
        }

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/is-authenticated/${sb_id.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          console.warn(
            "is-authenticated returned non-ok status",
            response.status
          );
          return false;
        }

        const data = await response.json();
        console.log("auth poll:", data);
        if (data.authenticated) {
          setEmailConfirm(true);
          // stop polling
          if (intervalId) clearInterval(intervalId);
          isPayment ? navigate("/payment") : navigate("/dashboard");
          return true;
        }

        return false;
      } catch (error) {
        console.error("Error checking authentication:", error);
        return false;
      }
    };

    // run immediately then poll
    (async () => {
      const ok = await checkAuthentication();
      if (ok) return;
      intervalId = setInterval(async () => {
        attempts += 1;
        if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          console.log("Auth poll: max attempts reached");
          return;
        }
        await checkAuthentication();
      }, intervalMs);
    })();
  }, []);

  return (
    <div className="email-confirm-container">
      {emailConfirm === true ? (
        <h2>
          Thank you for confirming your email, you can now close this page
        </h2>
      ) : (
        <div className="unverified">
          <h1>Two factor authentication</h1>
          <h3>Please check your email to authenticate your account</h3>
          <h3>Thank you!</h3>
        </div>
      )}
    </div>
  );
};

export default EmailConfirmation;
